import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

/**
 * Permite acesso a /reativacao somente para tokens com claim `escopo = "reativacao"`.
 * Tokens completos voltam para /inicio; sem token, vai para /login.
 */
export const ReativacaoGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const token = localStorage.getItem('token');

  if (!token || token === 'null' || token === 'undefined') {
    return router.parseUrl('/login');
  }

  try {
    const helper = new JwtHelperService();
    if (helper.isTokenExpired(token)) {
      return router.parseUrl('/login');
    }
    const decoded: any = helper.decodeToken(token);
    const escopo = decoded?.escopo ?? decoded?.Escopo;
    return escopo === 'reativacao' ? true : router.parseUrl('/inicio');
  } catch {
    return router.parseUrl('/login');
  }
};
